import { useEffect, useState } from "react"
import Select from 'react-select'
import { useDispatch, useSelector } from "react-redux"
import { useAuthState } from "../../../helper/Context/context"
import { MonthDDLAPI } from "../../../helper/Redux/Slices/DDLSlice/DDLSlice"

export const MonthDDL = (props) => {

    const { MonthID, setMonthID } = props

    const userDetails = useAuthState();
    const { Month, setMonth, CurrentMonth } = userDetails
    const { UserID, token } = userDetails.user

    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token
        }
        dispatch(MonthDDLAPI({ data }))
    }, [])

    const { DDLData } = useSelector(state => state.MonthDDLData)

    useEffect(() => {
        handleMonthDDL()
    }, [DDLData])

    const handleMonthDDL = () => {
        if (DDLData && DDLData.table && DDLData.table.length > 0) {
            let list = DDLData.table.map((item, index) => ({
                value: item.m_MonthID,
                label: item.monthName
            }))
            const currentMonthOption = list.find((option) => String(option.value) === String(CurrentMonth)) || list[0]
            const selectedMonth = Month.ID ? { value: Month.ID, label: Month.Label } : currentMonthOption

            setMonthID({
                DDL: list,
                ID: selectedMonth?.value || 0,
                Label: selectedMonth?.label || "Month..."
            })
            if (!Month.ID && currentMonthOption) {
                setMonth({ ...Month, ID: currentMonthOption.value, Label: currentMonthOption.label })
            }
        }
        else {
            setMonthID({
                DDL: [],
                ID: 0,
                Label: "Month...",
            })
        }
    }

    const handleChangeMonth = (e) => {
        setMonthID({ ...MonthID, ID: e.value, Label: e.label })
        setMonth({ ...Month, ID: e.value, Label: e.label })
    }

    const handleClearMonth = (e) => {
        setMonthID({ ...MonthID, ID: 0, Label: "Month..." })
        setMonth({ ...Month, ID: 0, Label: "Month..." })
    }

    return (
        <>
            <div className="d-flex align-items-center" style={{ marginTop: '-2px' }}>
                <Select
                    isClearable
                    id='DDLID'
                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused ? 'transparent' : 'transparent',
                            borderColor: 'white',
                            boxShadow: 'none',
                            maxWidth: '200px'
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999, position: "absolute" }),
                    }}
                    isSearchable
                    // isClearable
                    maxMenuHeight={128}
                    value={{ value: MonthID.ID, label: MonthID.Label }}
                    onChange={(e) => {
                        e ?
                            handleChangeMonth(e)
                            :
                            handleClearMonth(e)

                    }}
                    options={MonthID.DDL}
                />
            </div>





        </>
    )
}